<template>
    <div class="animated fadeIn container-fluid">
        <h2>{{ $t('menu.params_comparison') }}</h2>
        <div v-if="project_detail">
            <CompareChart :devices="all_devices" :project_id="project_detail.id" :project_role="project_detail.user_role" :timezone="project_detail.timezone"></CompareChart>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CompareChart from '@/views/device/Chart_Compare'

export default {
    components: {
        CompareChart,
    },
    data () {
        return {
            all_devices: [],
        }
    },
    // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
    beforeRouteUpdate (to, from, next)
    {
        // console.log(to.params.projectID + ' ?' + Math.random());
        this.getProject(to, from, next);
    },
    mounted ()
    {
        this.getProject();
    },
    computed: {
        ...mapState({
            'project_detail': state => state.project.project_detail,
            'project_devices': state => state.project.project_devices,
            // 'cropperiod_detail': state => state.cropperiod.cropperiod,
        }),

        projID () {
        return this.$route.params.projectID;
        },

    },
    // watch: {

    //     is_developer (val, oldVal)
    //     {
    //         if (val) this.getProject();
    //         else     this.$router.push({ name: 'Page404' })
    //     },
    // },
    methods: {

        getProject (to = undefined, from = undefined, next = undefined)
        {
            let _projID = ( next ? to.params.projectID : this.projID )

            if (_projID)
            {
                this.$store.dispatch('project/getProjectDetail', _projID)
                .then( res => {

                    // 取得專案 detail 後撈取地圖需要資訊
                    this.getProjectDevices(_projID);

                    if (next) next();

                })
                .catch( err => {
                })
            }
        },


        getProjectDevices (_projectID)
        {
            this.$store.dispatch('project/getProjectDevices', _projectID)
                .then( res => {

                    this.all_devices = []
                    this.project_devices.gateways.forEach( _GW => {

                        _GW.devices.forEach( _D => {

                            // 不列出 camera
                            if ( _D.type == 'camera' )
                            {
                                // Do Nothing
                            }
                            // 過濾掉重複 hashid 的裝置
                            else if ( this.all_devices.find( _find_D => _find_D.hashid === _D.hashid ) == undefined )
                            {
                                this.all_devices.push( _D )
                            }
                        })
                    })

                })
                .catch( err => {
                    this.all_devices = []
                })

            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'read',
                detail: {
                    page: 'comparison',
                    action: 'enter comparison',
                    querySettings: {
                        'project ID':     _projectID,
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },


    }
}
</script>
